import React from 'react';
import { STARTUPS } from '../data/startups';
import { StartupCard } from './StartupCard';
import { Sparkles } from 'lucide-react';
export function FeaturedStartups() {
  const featured = STARTUPS.filter(s => s.isFeatured).slice(0, 3);
  if (featured.length === 0) return null;
  return <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8" data-id="element-17">
      <div className="mb-8 flex items-center gap-2" data-id="element-18">
        <Sparkles className="h-5 w-5 text-[#FF6B1A]" data-id="element-19" />
        <h2 className="text-xl font-semibold tracking-tight text-neutral-900" data-id="element-20">
          Featured this week
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-21">
        {featured.map(startup => <StartupCard key={startup.id} startup={startup} variant="featured" data-id="element-22" />)}
      </div>
    </section>;
}